import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";
var useCreateMeeting = function useCreateMeeting() {
  return useMutation(["createMeeting"], function (formData) {
    return servicesUtils.postService("/recordings/create/", formData);
  });
};
export default useCreateMeeting;